import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryApi } from '../../utilities/apiEndpointUtility';
import { failureMessage } from '../Notifications/notificationsSlice';

import {
	getProjects,
	getProjectsCompleted,
	getProjectsFailed
} from './projectsSlice';

export const getProjectsEpic = (action$, state$) =>
	action$.pipe(
		ofType(getProjects.type),
		mergeMap(async (action) => {
			try {
				// const { search, skip, take } = action.payload;

				const response = await axios.get(`${primaryApi()}/api/v1/projects`);

				return response.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getProjectsCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(getProjectsFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export default [getProjectsEpic];
